'use strict';

// Constructor
var Accordions = function() {
	//Accordions
	$('.accordion-title').on('click', function(){
		$(this).find('.toggle').toggleClass('active')
	});
}

module.exports = Accordions;
